import { Fancybox } from '@fancyapps/ui'
import Splide from '@splidejs/splide'
import { loadSpicySections } from './components/tabs'
import { gotResizeMessage } from './components/iframe-resize-host'
;
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		// Load Tabbed Content
		if (document.querySelectorAll('spicy-sections').length > 0 && !window.acf) {
			loadSpicySections()
		}
		const elms = document.getElementsByClassName('splide')
		if (elms) {
			for (var i = 0; i < elms.length; i++) {
				new Splide(elms[i]).mount()
			}
		}

		//Responsive height iframes
		window.addEventListener("message", gotResizeMessage, false);
	})

	if (document.querySelector('.home .stepper_content')) {
		let currentStep = null
		document.querySelectorAll('.steps-container .step').forEach((step) => {
			if (!currentStep) {
				step.classList.add('active')
				currentStep = step
			}
			step.addEventListener('click', (e) => {
				currentStep.classList.remove('active')
				step.classList.add('active')
				currentStep = step
			})
		})
	}

	if (document.querySelector('.section-type-stepper')) {
		let currentStep = null
		document.querySelectorAll('.steps-container .step').forEach((step) => {
			if (!currentStep) {
				step.classList.add('active')
				currentStep = step
			}
			step.addEventListener('click', (e) => {
				currentStep.classList.remove('active')
				step.classList.add('active')
				currentStep = step
			})
		})
	}

	if (document.getElementById('open-roles')) {
		const rolesList = document.querySelector('spicy-sections')
		const roles = document.querySelectorAll('.open-roles-list .role')
		let location = document.querySelector(
			'.roles-filters #filter-locations select'
		).value
		let team = document.querySelector(
			'.roles-filters #filter-teams select'
		).value

		document.querySelectorAll('.roles-filters select').forEach((selector) => {
			selector.addEventListener('change', (e) => {
				location = document.querySelector(
					'.roles-filters #filter-locations select'
				).value
				team = document.querySelector(
					'.roles-filters #filter-teams select'
				).value

				let filteredRoles = ''
				roles.forEach((role) => {
					let locationMatch = true
					let teamMatch = true

					if (location !== 'All Locations') {
						locationMatch = location === role.getAttribute('data-location')
					}
					if (team !== 'All Teams') {
						teamMatch = team === role.getAttribute('data-team')
					}

					if (locationMatch && teamMatch) {
						filteredRoles += role.outerHTML
					}
				})

				rolesList.innerHTML = filteredRoles

				if (filteredRoles === '') {
					document.getElementById('no-open-roles').classList.remove('is-hidden')
				} else {
					document.getElementById('no-open-roles').classList.add('is-hidden')
				}
			})
		})
	}

	const scrollTrigger = (selector, options = {}) => {
		let elements = document.querySelectorAll(selector)
		elements.forEach((element) => {
			addObserver(element, options)
		})
	}

	const addObserver = (element, options) => {
		if (!('IntersectionObserver' in window)) {
			// Simple fallback
			// The animation/callback will be called immediately so
			// the scroll animation doesn't happen on unsupported browsers
			if (options.callBack) {
				options.callBack(element)
			} else {
				entry.target.classList.add('active')
			}
			// We don't need to execute the rest of the code
			return
		}

		let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (options.callBack) {
						options.callBack(element)
					} else {
						entry.target.classList.add('active')
					}
					observer.unobserve(entry.target)
				}
			})
		}, options)
		observer.observe(element)
	}

	if (document.querySelector('.circular-chart.has-scroll-animation')) {
		scrollTrigger('.circular-chart.has-scroll-animation', {
			rootMargin: '-160px',
		})
	}
	
})()
